import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import NewsFeed from "@/components/NewsFeed";
import JoinJgw from "@/components/JoinJgw";
import About from "@/components/About";
import Advertise from "@/components/Advertise";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import StickyJoinButton from "@/components/StickyJoinButton";
import Admin from "@/pages/Admin";

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <NewsFeed />
      <JoinJgw />
      <About />
      <Advertise />
      <ContactForm />
    </main>
    <Footer />
    <StickyJoinButton />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.05, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-ink font-sans text-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: { borderRadius: 12, background: "#1A1A1E", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" },
        }}
      />
    </div>
  );
}

export default App;
